module.exports = __webpack_public_path__ + "img/paper-red-sm-min.27f14b72.jpg";